import { DirectionalHint } from "@fluentui/react";
import React from "react";

import { TooltipHost } from "../../surfaces/tooltip/TooltipHost";
import { Theme } from "../../theme/Theme";
import { ButtonProps } from "./ButtonProps";
import { DefaultButton } from "./DefaultButton";

export interface BreadcrumbButtonProp extends Pick<ButtonProps, "styles"> {
    tooltipContent?: JSX.Element;
    isCurrentItem?: boolean;
    directionalHint?: DirectionalHint;
    text: string;
    onClick?(): void;
}

export const BreadcrumbButton: React.FunctionComponent<BreadcrumbButtonProp> = (props: BreadcrumbButtonProp) => {
    const handleClick = () => {
        if (props.onClick) props.onClick();
    };

    return (
        <TooltipHost
            content={props.tooltipContent}
            directionalHint={props.directionalHint ?? DirectionalHint.rightTopEdge}
        >
            <DefaultButton
                text={props.text}
                styles={{
                    root: { border: "none", background: Theme.palette.neutralLighterAlt, padding: 0 },
                    label: { fontSize: 18, fontWeight: props.isCurrentItem ? 600 : 400 },
                    ...props.styles
                }}
                onClick={handleClick}
            />
        </TooltipHost>
    );
};
